module.exports = __webpack_public_path__ + "static/media/gift_banner.5d01de06.svg";